
import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { fetchDiocesan } from '@/services/api';
// fetchDiocesan

interface DiocesanInfo {
  photo: string;
  name: string;
}

const Bishop = () => {
  const [loading, setLoading] = useState(true);
  const [diocesan, setDiocesan] = useState<DiocesanInfo | null>(null);
  useEffect(() => {
    setLoading(true)
    const loadDiocesan = async () => {
      try {
        const res = await fetchDiocesan();
        setDiocesan(res.data[0]); // Because it's returned as an array
      } catch (err) {
        console.error('Failed to fetch diocesan info:', err);
      } finally {
        setLoading(false)
      }
    };
    loadDiocesan();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 py-16 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading information...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Our Lord Bishop
          </h1>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Bishop's Photo */}
          <div className="lg:col-span-1">
            <Card className="border-none shadow-lg">
              <CardContent className="p-6">
                <div className="aspect-[3/4] bg-gradient-to-b from-purple-100 to-purple-200 rounded-lg overflow-hidden mb-4">
                  <div className="w-full h-full bg-gray-300 flex items-center justify-center">
                    <img src={diocesan.photo} />
                    {/* <div className="text-center">
                      <div className="w-32 h-32 bg-purple-600 rounded-full mx-auto mb-4 flex items-center justify-center">
                        <span className="text-4xl text-white">👨‍💼</span>
                      </div>
                      <p className="text-gray-600">Bishop's Official Photo</p>
                    </div> */}
                  </div>
                </div>
                <div className="text-center">
                  <h3 className="text-xl font-bold text-gray-900">{diocesan.name}</h3>
                  <p className="text-purple-600 font-semibold">Bishop, Diocese of Ibadan South</p>
                  <p className="text-gray-600 text-sm mt-2">Anglican Communion</p>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Bishop's Profile */}
          <div className="lg:col-span-2 space-y-6">
            <Card className="border-none shadow-lg">
              <CardHeader>
                <CardTitle className="text-2xl text-purple-700">Biography</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p className="text-gray-700">
                  The Right Reverend AkinTunde Adedayo Popoola is the current Bishop of the Diocese of
                  Ibadan South, Anglican Communion. Born on July 15, he brings decades of spiritual
                  leadership and a passion for innovation, evangelism, and education to his ministry.
                </p>
                <p className="text-gray-700">
                  Raised in a Christian family and deeply convicted during his secondary school years, Bishop Popoola
                  surrendered to Christ and began a life of committed discipleship. He studied Computer Engineering
                  at Obafemi Awolowo University, Ile-Ife, and later responded to a divine call to ordained ministry
                  while serving in various roles across the Church.
                </p>
                <p className="text-gray-700">
                  He was ordained a Deacon on 4th August 1996 and a Priest on 29th June 1997. After a successful career in ICT, he fully
                  transitioned to full-time ministry in 2001. Throughout his ministry, Bishop Popoola has served in various parishes across the Dioceses of Ibadan, Ibadan North, Abuja, Kubwa, and Offa. A passionate evangelist, he has been actively involved in church planting, growth, and strategic expansion wherever he served.
                </p>
                <p className="text-gray-700">
                  He was preferred a Canon in 2002 and elevated to Archdeacon in 2005. He later served as Director of Communications for the Church of Nigeria
                  and played a key role in digitalizing communication across Anglican dioceses. He was consecrated as
                  Bishop of Offa Diocese on 13th July, 2008 and translated to Ibadan South Diocese on 28th June, 2018.
                </p>
                <p className="text-gray-700">
                  Bishop Popoola is married to Dr. Oyebola O. Popoola, a physicist, and they are blessed with three
                  children: Toromoluwa, Oluwasemilore, and Shalom.
                </p>
              </CardContent>
            </Card>


            <Card className="border-none shadow-lg">
              <CardHeader>
                <CardTitle className="text-2xl text-purple-700">Education & Qualifications</CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-purple-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                    <span>B.Sc. in Computer Engineering – Obafemi Awolowo University, Ile-Ife (1989)</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-purple-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                    <span>Diploma in Theology – Immanuel College of Theology, Ibadan (1998)</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-purple-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                    <span>Master in Managerial Psychology (MMP) – University of Ibadan (2001)</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-2 h-2 bg-purple-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                    <span>Master of Divinity (M.Div.) – Theological College of Northern Nigeria, Bukuru (2009)</span>
                  </li>
                  {/* <li className="flex items-start">
                    <span className="w-2 h-2 bg-purple-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                    <span>Doctoral Candidate – Crowther Graduate Theological Seminary, Abeokuta</span>
                  </li> */}
                </ul>
              </CardContent>
            </Card>


            <Card className="border-none shadow-lg">
              <CardHeader>
                <CardTitle className="text-2xl text-purple-700">Ministry Focus</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Areas of Ministry</h4>
                    <ul className="space-y-1 text-gray-700">
                      <li>• Evangelism & Church Planting</li>
                      <li>• Digital & Communication Ministry</li>
                      <li>• Youth & Campus Ministry</li>
                      <li>• Clergy Training & Discipleship</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Special Interests</h4>
                    <ul className="space-y-1 text-gray-700">
                      <li>• Strategic Church Growth</li>
                      <li>• Biblical Discipleship</li>
                      <li>• Information Technology in Ministry</li>
                      <li>• Ministerial Leadership Development</li>
                    </ul>
                  </div>
                </div>
              </CardContent>
            </Card>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Bishop;
